import { initializeFaro, getWebInstrumentations } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { getEnvironment } from '../config/configurations';

class FaroService {
  constructor() {
    this.instance = null;
  }

  init(config) {
    if (!config.grafanaFaroUrl || this.instance) {
      return this.instance;
    }

    const appName =
      process.env.NODE_ENV === 'production' ? `${getEnvironment()}-edulai-skillschecker` : 'edulai-skillschecker';

    this.instance = initializeFaro({
      url: config.grafanaFaroUrl,
      app: {
        name: appName,
        version: process.env.REACT_APP_VERSION,
        environment: process.env.NODE_ENV
      },
      instrumentations: [...getWebInstrumentations(), new TracingInstrumentation()]
    });

    return this.instance;
  }

  getInstance() {
    return this.instance;
  }
}

export default new FaroService();
